import consumer from "channels/consumer"

export default class {
  constructor(scheduleId, proficienciesBySubjectTableEl, proficienciesTableEl, alertEl) {
    this.scheduleId = scheduleId
    this.proficienciesBySubjectTableEl = proficienciesBySubjectTableEl
    this.proficienciesTableEl = proficienciesTableEl
    this.alertEl = alertEl
  }

  start() {
    this.subscription = consumer.subscriptions.create({ "channel": "BarReview::PerformanceStatsChannel", "schedule_id": this.scheduleId }, {
      received: (data) => {
        if (data.action === "update") {
          if (this.proficienciesBySubjectTableEl !== null) {
            this.proficienciesBySubjectTableEl.outerHTML = data.proficienciesBySubjectTableHTML
          }
          this.proficienciesTableEl.outerHTML = data.proficienciesTableHTML
          this.alertEl.outerHTML = data.alertHTML
          consumer.subscriptions.remove(this.subscription) // the page no longer needs to subscribe for changes.
        }
      }
    })
  }
}
